import { useEffect, useState } from 'react'
import axios from 'axios'
import { useConfig } from '../../Providers/ConfigProvider';
import useDebounce from '../../Hooks/useDebounce';
import { getAccessToken } from '../../Services/TokenService';
import { GetCustomerDiscounts } from '../../Services/CustomerService';
import { validateZipCode } from '../../Helpers/ValidatorHelper';

export default function useLoadingContractors(filterCriteria, pageNumber) {
  const { useDebounceWithStrongValueCheck } = useDebounce()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [contractors, setContractors] = useState([])
  const [hasMore, setHasMore] = useState(false)
  const [resultNumber, setResultNumber] = useState(0)

  const { api } = useConfig()

  const debouncedFilterCriteria = useDebounceWithStrongValueCheck(filterCriteria, 500)


  const handleGetSalesTeams = async () => {
    try {
      let res = await api.get('/api/v1/Customer/getCustomersSalesTeams')
      return res.data
    } catch (error) {
      console.log(error)
      return []
    }
  }

  useEffect(() => {
    if (shouldBlockFetch(debouncedFilterCriteria)) {
      return // Przerywamy - nie czyścimy listy, jeśli wpisywany jest tylko błędny zipCode
    }
    setContractors([])
  }, [debouncedFilterCriteria])

  useEffect(() => {
    const source = axios.CancelToken.source()

    handleGetCustomers(source.token)

    return () => {
      source.cancel()
    }
  }, [debouncedFilterCriteria, pageNumber])

  const handleGetCustomers = (cancelToken) => {
    if (shouldBlockFetch(debouncedFilterCriteria)) {
      setLoading(false) //DK : blokujemy pusty strzał jak ktoś tylko wpisał niepoprawny zipCode
      return
    }

    setLoading(true)
    setError(false)
    const searchPayload = { ...filterCriteria }

    if (searchPayload.zipCode && searchPayload.zipCode.length != 5) {
      searchPayload.zipCode = '';
    }

    api.post(`/api/v1/Customer/getCustomers`, searchPayload, {
      cancelToken: cancelToken,
      params: {
        pageNumber
      }
    }).then(res => {
      setContractors(prevProducts => [...prevProducts, ...res.data.customers])
      setResultNumber(res.data.resultNumber)
      setHasMore(res.data.customers.length > 9)
      setLoading(false)
    })
      .catch(e => {
        if (axios.isCancel(e)) {
          return
        }
        console.error(e)
      })
  }

  const areOtherFiltersEmpty = (criteria) => {
    if (!criteria) {
      return false
    }
    return !criteria.textSearch?.trim() && !criteria.salesTeam?.trim() && !criteria.city?.trim()
  }

  const shouldBlockFetch = (criteria) => {
    return areOtherFiltersEmpty(criteria) && criteria?.zipCode && criteria?.zipCode.length !== 5
  }

  const handleChangeContractorDiscount = async (recNo, discount, prevDiscount, custId, userCode, operatorLogin) => {
    try {
      let res = await api.post(`/api/v1/Customer/updateCustomerDiscount?recNo=${recNo}&discount=${discount}&prevDiscount=${prevDiscount}&custId=${custId}
        &userCode=${userCode}&operatorLogin=${operatorLogin}`, {})
      return res.data
    } catch (e) {
      console.log(e)
      return false
    }
  }

  const handleGetCustomerDiscounts = async () => {
    try {
      let res = await GetCustomerDiscounts(api)
      return res.data
    } catch (error) {
      console.error(error)
      return []
    }
  }

  return {
    loading,
    error,
    contractors,
    hasMore,
    resultNumber,
    handleGetSalesTeams,
    handleChangeContractorDiscount,
    handleGetCustomerDiscounts,
  }
}